import type CSVMapping from '~/types/CSVMapping';

import { type Field } from '~/types/CSVMapping';
import { type TrackingReference } from '~/utils/TrackingHelper/types';

import { ActionKeys } from './constants';

export const uploadCSV = (file: Blob | string) =>
  <const>{
    payload: {
      file,
    },
    type: ActionKeys.CSV_IMPORT_FILE_UPLOAD,
  };

type UploadCSVPayload = {
  fileUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mapping: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userValues: any;
};

// TODO: Remove payload type and pass params directly to functions
export const uploadCSVSuccess = (payload: UploadCSVPayload) =>
  <const>{
    payload,
    type: ActionKeys.CSV_IMPORT_FILE_UPLOAD_SUCCESS,
  };

// TODO: Add types to function params
export const uploadCSVError = (errorMessage: string, errorTitle: string) =>
  <const>{
    payload: {
      errorMessage,
      errorTitle,
    },
    type: ActionKeys.CSV_IMPORT_FILE_UPLOAD_ERROR,
  };

export const changeCSVFieldMapping = (index: number, field: Field, colName: string) =>
  <const>{
    payload: {
      colName,
      field,
      index,
    },
    type: ActionKeys.CSV_IMPORT_CHANGE_FIELD_MAPPING,
  };

export const changeCSVTemplate = (value: number) =>
  <const>{
    type: ActionKeys.CSV_IMPORT_CHANGE_TEMPLATE,
    value,
  };

export const fetchCSVTemplates = () =>
  <const>{
    type: ActionKeys.CSV_IMPORT_FETCH_TEMPLATES,
  };

interface FetchCSVTemplatesSuccessPayload {
  templates: CSVMapping[];
}

// TODO: Remove payload type and pass templates directly to functions
export const fetchCSVTemplatesSuccess = (payload: FetchCSVTemplatesSuccessPayload) =>
  <const>{
    payload,
    type: ActionKeys.CSV_IMPORT_FETCH_TEMPLATES_SUCCESS,
  };

// TODO: Add types to function params
export const fetchCSVTemplatesError = (errorMessage: string, errorTitle: string) =>
  <const>{
    payload: {
      errorMessage,
      errorTitle,
    },
    type: ActionKeys.CSV_IMPORT_FETCH_TEMPLATES_ERROR,
  };

export const showDeleteCSVTemplateModal = () =>
  <const>{
    type: ActionKeys.CSV_IMPORT_DELETE_TEMPLATE_MODAL_OPEN,
  };

// TODO: Add types to function params
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteCSVTemplate = (templateId: any) =>
  <const>{
    payload: {
      templateId,
    },
    type: ActionKeys.CSV_IMPORT_DELETE_TEMPLATE,
  };

// TODO: Add types to function params
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteCSVTemplateSuccess = (payload: any) =>
  <const>{
    payload: {
      deletedTemplateId: payload.deletedTemplateId,
      templates: payload.templates,
    },
    type: ActionKeys.CSV_IMPORT_DELETE_TEMPLATE_SUCCESS,
  };

export const deleteCSVTemplateError = (errorMessage: string, errorTitle: string) =>
  <const>{
    payload: {
      errorMessage,
      errorTitle,
    },
    type: ActionKeys.CSV_IMPORT_DELETE_TEMPLATE_ERROR,
  };

// TODO: Add types to function params
export const saveCSVTemplateSuccess = (
  fileUrl: string,
  templateId: unknown,
  trackingReference: TrackingReference,
) =>
  <const>{
    payload: {
      fileUrl,
      templateId,
      trackingReference,
    },
    type: ActionKeys.CSV_IMPORT_SAVE_TEMPLATE_SUCCESS,
  };

// TODO: Add types to function params
export const saveCSVTemplateError = (errorMessage: string, errorTitle: string) =>
  <const>{
    payload: {
      errorMessage,
      errorTitle,
    },
    type: ActionKeys.CSV_IMPORT_SAVE_TEMPLATE_ERROR,
  };

export const openSaveCSVModal = () =>
  <const>{
    type: ActionKeys.CSV_IMPORT_OPEN_SAVE_CSV_TEMPLATE_MODAL,
  };

export const closeSaveCSVModal = () =>
  <const>{
    type: ActionKeys.CSV_IMPORT_CLOSE_SAVE_CSV_TEMPLATE_MODAL,
  };

export const importCSVOrdersSuccess = () =>
  <const>{
    type: ActionKeys.CSV_IMPORT_ORDERS_SUCCESS,
  };

export const importCSVOrdersError = (errorMessage: string, errorTitle: string) =>
  <const>{
    payload: {
      errorMessage,
      errorTitle,
    },
    type: ActionKeys.CSV_IMPORT_ORDERS_ERROR,
  };

// TODO: Add types to function params
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const openErrorMessageBox = (text: any, fields: any) =>
  <const>{
    payload: {
      fields,
      text,
    },
    type: ActionKeys.CSV_IMPORT_OPEN_ERROR_MESSAGE,
  };

export const cleanState = () =>
  <const>{
    type: ActionKeys.CSV_CLEAN_STATE,
  };

export type CSVImportActions =
  | ReturnType<typeof changeCSVFieldMapping>
  | ReturnType<typeof changeCSVTemplate>
  | ReturnType<typeof cleanState>
  | ReturnType<typeof closeSaveCSVModal>
  | ReturnType<typeof deleteCSVTemplate>
  | ReturnType<typeof deleteCSVTemplateError>
  | ReturnType<typeof deleteCSVTemplateSuccess>
  | ReturnType<typeof fetchCSVTemplates>
  | ReturnType<typeof fetchCSVTemplatesError>
  | ReturnType<typeof fetchCSVTemplatesSuccess>
  | ReturnType<typeof importCSVOrdersError>
  | ReturnType<typeof importCSVOrdersSuccess>
  | ReturnType<typeof openErrorMessageBox>
  | ReturnType<typeof openSaveCSVModal>
  | ReturnType<typeof saveCSVTemplateError>
  | ReturnType<typeof saveCSVTemplateSuccess>
  | ReturnType<typeof showDeleteCSVTemplateModal>
  | ReturnType<typeof uploadCSV>
  | ReturnType<typeof uploadCSVError>
  | ReturnType<typeof uploadCSVSuccess>;
